import React, {
  useState,
} from 'react';
import {
  Page,
  Document,
} from 'react-pdf/dist/esm/entry.webpack';

import {
  Spinner,
  NotFound,
  Pagination,
} from 'web-components';

import * as S from '../styled';

const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};

type Props = {
  file: string;
};

const Preview = ({ file }: Props) => {
  const [pages, setPages] = useState({
    numPages: 1,
    pageNumber: 1,
  });

  return (
    <S.Preview>
      <Document
        file={file}
        error={<NotFound />}
        loading={<Spinner />}
        options={options}
        onLoadSuccess={({ numPages }) => {
          setPages({
            ...pages,
            numPages,
          });
        }}
      >
        <Page width={550} pageNumber={pages.pageNumber} />
      </Document>

      {pages.numPages > 1 && (
        <Pagination
          count={pages.numPages}
          current={pages.pageNumber}
          goToPage={(page: number) => {
            setPages({
              ...pages,
              pageNumber: page,
            });
          }}
        />
      )}
    </S.Preview>
  );
};

export default Preview;
